import { ExportColumn } from '../../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'applicationName',
    header: 'Application',
    type: 'text',
  },
  {
    key: 'recoverySLA',
    header: 'Recovery SLA',
    placeholder: 'Not Provided',
    type: 'text',
  },
  {
    key: 'hostingLocation',
    header: 'Hosting Location',
    placeholder: 'Not Provided',
    type: 'text',
  },
  {
    key: 'drPlanInPlace',
    header: 'DR Plan In Place?',
    placeholder: 'Not Provided',
    type: 'text',
  },
  {
    key: 'planOwnerfirstName',
    header: 'Plan Owner',
    type: 'text',
    placeholder: 'Not Provided',
    width: 35,
  },
  {
    key: 'planOwnerlastName',
    header: 'Plan Owner Last Name',
    type: 'text',
    placeholder: 'Not Provided',
    width: 35,
  },
  {
    key: 'email',
    header: 'Email',
    type: 'text',
    placeholder: 'Not Provided',
    width: 40,
  },
  {
    key: 'phone',
    header: 'Phone',
    type: 'text',
    placeholder: 'Not Provided',
  },
];
